import type { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router'

import { DEFAULT_LOGOUT_REDIRECT } from '@/constants/routes'
import { useAuth } from '@/providers//auth-provider'

export const PrivateRouteProvider = ({ children }: PropsWithChildren) => {
  const location = useLocation()

  const { isAuth } = useAuth()

  if (!isAuth) {
    return (
      <Navigate
        to={DEFAULT_LOGOUT_REDIRECT}
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  return children
}
